import { DataHubActions } from '../../dataHubActions';
import { ViewContentCreateSchema } from './viewContentCreateSchema';
export class ViewContentEditSchema extends ViewContentCreateSchema {
    constructor(params) {
        super(params);
        this.action = DataHubActions.ViewContentEdit;
    }
}
